import { createContext } from "react";

const InternalFundContext = createContext();

export default InternalFundContext;